/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Audio quality rating, computed by us
 * @nullable
 */
export type CallAudioRating = (typeof CallAudioRating)[keyof typeof CallAudioRating] | null;

export const CallAudioRating = {
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  UNCLASSIFIED: 'unclassified',
} as const;
